import { css, ListItem, styled } from '@mui/material';

export const TooltipListItem = styled(ListItem)(
  () => css`
    display: list-item;
  `,
);
